import styled from '@emotion/styled';
import { space } from 'styled-system';
import { StyledProps } from './Footer.types';
import { Theme } from './../Box.types';

export default styled.div<StyledProps, Theme>`
  ${space}
  border-top: 1px solid var(--color-indigo-t1);
`;
